import { createRef, RefObject, useRef } from "react";

// Lazily grows a pool of stable ref objects for a list of items whose count
// isn't known until data loads (e.g. one ref per PDF-page chunk of a
// variable-length list). Refs already handed out are never replaced, so
// their `.current` values stay valid across renders.
export default function useRefPool<T extends HTMLElement = HTMLDivElement>(
  count: number
): RefObject<T>[] {
  const pool = useRef<RefObject<T>[]>([]);
  while (pool.current.length < count) {
    pool.current.push(createRef<T>());
  }
  return pool.current.slice(0, count);
}
